<template>
    <div
        class="Input Input--dropdown"
        :class="{
            'Input--desktop': desktop,
            'Input--labelLeft' : labelPosition === 'left'
        }"
    >
        <label
            v-if="label"
            class="Input-labelDropdown"
            :for="name"
            :class="{
                'Input--white': white,
                'Input--error': error,
        }">
            {{ label }}:
        </label>
        <select
            v-if="isMobile"
            :name="name"
            :value="value"
            @input="onChange"
        >
            <option
                disabled
                value="">Choose one
            </option>
            <option
                v-for="option in options"
                :value="option.value">{{ option.label }}
            </option>
        </select>
        <div
            class="Input-fakeDropdown"
            :class="{
                'Input-fakeDropdown--active': expandedOptions,
                'Input-fakeDropdown--dimensions': dimensions

            }"
            v-if="!isMobile"
            @click.prevent="expandOptions">
            {{ currentOption }}
        </div>
        <ul
            class="Input-fakeOptions"
            :class="{
                'Input-fakeOptions--active': expandedOptions,
                'Input-fakeOptions--map': map,
                'Input-fakeOptions--dimensions': dimensions
            }"
        >
            <li
                v-for="option in options"
                class="Input-fakeOption"
                @click="selectOption(option)"
            >
                {{ option.label }}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'HempelDropdown',
    data() {
        return {
            expandedOptions: false,
            selectedOption: ''
        }
    },
    props: {
        value: {
            type: [Number, String]
        },
        options: {
            type: Array,
            required: true,
            default: () => []
        },
        label: {
            type: String,
            default: null
        },
        labelPosition: {
            type: String,
            default: 'top'
        },
        name: {
            type: String,
            default: null
        },
        white: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        },
        desktop: {
            type: Boolean,
            default: false
        },
        map: {
            type: Boolean,
            default: false
        },
        dimensions: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        currentOption() {
            if (!this.dimensions) {
                return this.selectedOption.length > 0
                    ? this.selectedOption
                    : this.$route.query.paintLocation
                        ? this.getCountry(this.$route.query.paintLocation)
                        : this.translation.find.answers.paintLocation[0].label
            }
            return this.translateUnit(this.value)
        }
    },
    methods: {
        onChange(e) {
            this.$emit('input', {
                value: e.target.value
            })
        },
        expandOptions() {
            this.expandedOptions = !this.expandedOptions
        },
        selectOption(option) {
            this.selectedOption = option.label
            this.expandedOptions = false
            this.$emit('input', {
                value: option.value
            })
        },
        getCountry(value) {
            const country = this.options.filter(option => option.value === `${value}`)
            return country[0].label
        },
        translateUnit(unit) {
            return unit === 'm'
                ? this.translation.calculate.answers.dimensions[0].values[0].label
                : this.translation.calculate.answers.dimensions[0].values[1].label
        }
    }
}
</script>
